import React,{useState} from 'react'
import { DemoPageStyle } from './Demo.styled'
import { useLocation } from "react-router-dom"
import TopBar from '../../components/TopBar/TopBar';
import Footer from '../../components/footer/Footer';
import { HeadingStyle } from '../../styles/HeadingStyles';
import { Bar } from 'react-chartjs-2';
import { Chart, registerables, Tooltip } from 'chart.js';
import { plugin } from 'postcss';
import { MainBodyStyle } from '../../styles/MainBodyStyles';

Chart.register(...registerables);


const DemoGraph = () => {
    const location = useLocation();
    const user=location?.state?.user
    let loginCounts=[]
    
    const labelfunction=(tooltipItem)=>{
        
        const str= parseInt(tooltipItem.raw) 
       
        const hour = Math.floor(str / 60)
        const min = str % 60
        

        return  [`${hour} hour${hour !== 1 ? 's' : ''} and ${min} minute${min !== 1 ? 's' : ''}`,`Login Count: ${loginCounts[tooltipItem.dataIndex]}`]
    }

   const processData = (data) => {
        
        // calculating Duration
        const groupedData = data.reduce((acc, { TimeStamp, Duration }) => {
            const date = new Date(TimeStamp).toISOString().split('T')[0]; // Extract the date part
            if (!acc[date]) {
                acc[date] = 0;
            }
            const sec= +Duration
            acc[date] += Math.floor(sec / 60) ; // Convert seconds to minutes and accumulate
            
            return acc;
        }, {});
        
        // calculating Login Count
        const groupedData2 = data.reduce((acc, { TimeStamp, LoginCount }) => {
            const date = new Date(TimeStamp).toISOString().split('T')[0]; // Extract the date part
            if (!acc[date]) {
                acc[date] = 0;
            }
            
            const count= LoginCount ? +LoginCount : 0
            acc[date] += count; 
            
       
            return acc;
        }, {});

        loginCounts=Object.values(groupedData2)
        

        const labels = Object.keys(groupedData);
        const durations = Object.values(groupedData);
        return { labels, durations };
    };

    const { labels, durations } = processData(user.records);
    // const { labels, durations } = processData(data);
    const chartData = {
        labels,
        datasets: [
            {
            label: 'Duration in Minutes',
            data: durations,
            backgroundColor: 'rgba(242, 136, 9, 0.6)',
            borderColor: 'rgba(242, 136, 9, 1)',
            borderWidth: 1,
            },
            
        ],
    };

    const options = {
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Minutes',
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Days',
                },
            },
        },
       plugins:{
        tooltip:{
            callbacks:{
              label:labelfunction  
            }
        }
       }
    };

  return (
    <DemoPageStyle>
        <TopBar authorized={true}  />
        <MainBodyStyle>
            <HeadingStyle>{user.email}</HeadingStyle>
            <div className='graphbar' style={{width:"50%",height:"50%"}}>
                <Bar 
                    datasetIdKey={user.email}
                    data={chartData}
                    options={options}
                    redraw={true}

                />
            </div>
        </MainBodyStyle>
         <Footer style="footer" />
    </DemoPageStyle>
  )
}

export default DemoGraph